import React from 'react';
import '../styles/Footer.css';

function Footer() {
  return (
    <footer>
      <p>&copy; 2024 Meena's Foods. All rights reserved.</p>
    </footer>
  );
}

export default Footer;